/** Room kept between a revealed item and the scroller edge: the widest fade mask (`fade-r` in styles/index.css). */
export const FADE_MASK_PX = 32

/**
 * Scrolls `item` horizontally inside `scroller` (tab rows, chip rows): centred when `center`, else only as far
 * as needed to sit `margin` px clear of the edges, where the fade masks are (Q-COMM-32, Q-SRCH-31). Rect based,
 * so it works whatever the item's offsetParent is. Clamped to the scroll range; no-op when nothing overflows.
 */
export function revealInScroller(
  scroller: HTMLElement,
  item: HTMLElement,
  { center = false, margin = FADE_MASK_PX }: { center?: boolean; margin?: number } = {},
): void {
  const max = scroller.scrollWidth - scroller.clientWidth
  if (max <= 0) return
  const box = scroller.getBoundingClientRect()
  const r = item.getBoundingClientRect()
  let left = scroller.scrollLeft
  if (center) left += r.left - box.left - (box.width - r.width) / 2
  else if (r.left < box.left + margin) left -= box.left + margin - r.left
  else if (r.right > box.right - margin) left += r.right - (box.right - margin)
  else return
  scroller.scrollTo({ left: Math.min(max, Math.max(0, Math.round(left))) })
}
